import { render, staticRenderFns } from "./SelecionarClientePedido.vue?vue&type=template&id=1e456f21&"
import script from "./SelecionarClientePedido.vue?vue&type=script&lang=js&"
export * from "./SelecionarClientePedido.vue?vue&type=script&lang=js&"
import style0 from "./SelecionarClientePedido.vue?vue&type=style&index=0&id=1e456f21&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports